function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2021. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React from 'react';
import Markdown from '../common/markdown.jsx';
import messages from '../../nls/setup/deploy/deploy.properties';
import Phase from '../common/model/phase';
import { SkeletonText } from '@carbon/react';
import ServicesList from '../common/services-list.jsx';
Object.assign = Object.assign || require('object-assign');
import '../../scss/setup/deploy/_sidebar.scss';
var SideBar = /*#__PURE__*/function (_React$Component) {
  function SideBar() {
    _classCallCheck(this, SideBar);
    return _callSuper(this, SideBar, arguments);
  }
  _inherits(SideBar, _React$Component);
  return _createClass(SideBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        availableCapabilities = _this$props.availableCapabilities,
        baseName = _this$props.baseName,
        phase = _this$props.phase,
        showTools = _this$props.showTools,
        template = _this$props.template;
      var templateData = template || {};
      var gitUrl = templateData.info && templateData.info["git url"];
      var gitBranch = templateData.info && templateData.info["git branch"];
      var showOutline = gitUrl || phase === Phase.LOADING;
      var servicesContent = /*#__PURE__*/React.createElement("span", null);
      if (baseName !== "empty-toolchain" && showTools) {
        if (template) {
          servicesContent = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
            className: "sidebar-label"
          }, messages.get("tools.title")), /*#__PURE__*/React.createElement(ServicesList, {
            services: availableCapabilities
          }));
        } else {
          servicesContent = /*#__PURE__*/React.createElement(SkeletonText, {
            className: "services-skeleton"
          });
        }
      }

      // Note gitUrl and gitBranch may be markdown, or plain text containing a URL.
      return /*#__PURE__*/React.createElement("aside", {
        className: "side-bar",
        "aria-label": messages.get("template.metadata")
      }, /*#__PURE__*/React.createElement("div", {
        className: "side-bar__toolchainData"
      }, showTools && showOutline && /*#__PURE__*/React.createElement("span", {
        className: "side-bar__template-info-header"
      }, messages.get("label.sidebar.templateinfo")), /*#__PURE__*/React.createElement("div", {
        className: "services-container"
      }, servicesContent), showOutline && /*#__PURE__*/React.createElement("div", {
        className: "side-bar__toolchainData__item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sidebar-label side-bar__toolchainData__label"
      }, /*#__PURE__*/React.createElement("p", null, messages.get("label.sidebar.giturl"))), phase === Phase.LOADING ? /*#__PURE__*/React.createElement("span", {
        className: "skeleton-container side-bar__toolchainData__value"
      }, /*#__PURE__*/React.createElement(SkeletonText, null)) : /*#__PURE__*/React.createElement(Markdown, {
        id: "gitUrl",
        className: "side-bar__toolchainData__value",
        content: gitUrl
      })), showOutline && /*#__PURE__*/React.createElement("div", {
        className: "side-bar__toolchainData__item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sidebar-label side-bar__toolchainData__label"
      }, /*#__PURE__*/React.createElement("p", null, messages.get("label.sidebar.gitbranch"))), phase === Phase.LOADING ? /*#__PURE__*/React.createElement("span", {
        className: "skeleton-container side-bar__toolchainData__value"
      }, /*#__PURE__*/React.createElement(SkeletonText, null)) : /*#__PURE__*/React.createElement(Markdown, {
        className: "side-bar__toolchainData__value",
        id: "gitBranch",
        content: gitBranch
      }))));
    }
  }]);
}(React.Component);
export { SideBar as default };